/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Placeholder_EmailInputs */



/**
* | output |
* | --- |
* | "you@example.com" |
*
* @param {Login_Placeholder_EmailInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_placeholder_email = /** @type {((inputs?: Login_Placeholder_EmailInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Placeholder_EmailInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("vous@exemple.com")
	if (locale === "es") return /** @type {LocalizedString} */ ("usuario@ejemplo.com")
	if (locale === "pt") return /** @type {LocalizedString} */ ("voce@exemplo.com")
	if (locale === "it") return /** @type {LocalizedString} */ ("tu@esempio.com")
	return /** @type {LocalizedString} */ ("you@example.com")
});